import React from 'react';
import './notFound.css';

export default function NotFound() {
  return (
    <main className="br-not-found">
      <h1>Nothing to see here.</h1>
      <img src="/assets/images/empty-typewriter.jpeg" alt="An empty typewriter" />
      <p>Are you sure you entered the right URL?</p>
      <a className="br-button br-button--primary br-button--large" href="/">
        Take me home
      </a>
    </main>
  );
}
